import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../PageEmptyState'

import PostIcon from '../../../icons/post.svg'

function PostListNoData({ actions }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={PostIcon}
      actions={actions}
      text={t('Newsboard.noDataKey')}
    />
  )
}

export default PostListNoData
